import { ChangeEvent } from 'react';
import { FormControl, FormControlLabel, Switch, FormHelperText } from '@mui/material';
import { withControl } from '@features/effector-form/hoc/withControl';

export const SwitchControl = withControl(
  ({ value, setValue, label, readOnly, disabled, helperText }) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      setValue(event.target.checked);
    };

    return (
      <FormControl>
        <FormControlLabel
          control={<Switch checked={value} onChange={handleChange} />}
          label={label}
          disabled={readOnly || disabled}
        />
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);
